const exportRouter = [
    {
        path: 'list-export',
        name: 'export',
        component: () => import('@/views/admin/export/index.vue'),
        meta: {
            model: 'export',
            requiresAuth: true,
        }
    },
    {
        path: 'list-export/boxs',
        name: 'exportBoxs',
        component: () => import('@/views/admin/export/box/index'),
        meta: {
            model: 'record_detail',
            requiresAuth: true,
        }
    },
    {
        path: "list-export/add",
        name: "addExport",
        component: () => import("@/views/admin/export/function"),
        default: true,
        meta: {
            model: "export",
            // requiresAuth: true,
        },
    },
    {
        path: "list-export/view/:id",
        name: "viewExport",
        component: () => import("@/views/admin/export/function"),
        default: true,
        meta: {
            model: "export",
            // requiresAuth: true,
        },
    },
];

export default exportRouter;